import { render, staticRenderFns } from "./ExpandedLead.vue?vue&type=template&id=5d98dd28&"
import script from "./ExpandedLead.vue?vue&type=script&lang=js&"
export * from "./ExpandedLead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports